import { render, staticRenderFns } from "./NewCompanyDetail.vue?vue&type=template&id=b361f21c"
import script from "./NewCompanyDetail.vue?vue&type=script&lang=js"
export * from "./NewCompanyDetail.vue?vue&type=script&lang=js"
import style0 from "./NewCompanyDetail.vue?vue&type=style&index=0&id=b361f21c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports